import assert from "owa-assert/lib/assert";
import type { IdentityInfo } from "owa-auth-types";
import { type MailboxInfo } from "owa-client-types";
import { getMailboxDiagnosticInfo } from "owa-feature-flags";

type FallbackFunction = () => IdentityInfo;

let fallbackIdentityInfoFunction: FallbackFunction | undefined = undefined;

export function setFallbackIdentityInfoFunction(fallback: FallbackFunction): void {
    fallbackIdentityInfoFunction = fallback;
}

export function callFallbackIdentityInfoFunction(mailboxInfoForDiagnostic?: MailboxInfo): IdentityInfo {
    assert(!!fallbackIdentityInfoFunction, "Call setFallbackIdentityInfoFunction to set the function", () => JSON.stringify(getMailboxDiagnosticInfo(mailboxInfoForDiagnostic)));
    return fallbackIdentityInfoFunction();
}
